
export default {
  name: 'AdminProductToolbar',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isExpanded: false,
      loading: false,
      variantsStats: {},
    }
  },

  computed: {
    issueLabels() {
      return {
        inactive: 'components.adminProductToolbar.reasonInactive',
        no_selectable_variant: 'components.adminProductToolbar.reasonNoVariant',
        pro_only: 'components.adminProductToolbar.reasonProOnly',
        unavailable: 'components.adminProductToolbar.reasonUnavailable',
      }
    },
    countryReasonLabels() {
      return {
        category: 'components.adminProductToolbar.countryReasonCategory',
        pack: 'components.adminProductToolbar.countryReasonPack',
        product: 'components.adminProductToolbar.countryReasonProduct',
      }
    },
    restrictedCountries() {
      return (this.product.restricted_countries || []).filter(
        country => this.countryReasonLabels[country.reason]
      )
    },
    visibilityIssues() {
      return (this.product.customer_visibility_issues || []).filter(
        issue => this.issueLabels[issue]
      )
    },
    isInactive() {
      return this.visibilityIssues.includes('inactive')
    },
    isAdmin() {
      return (
        this.$auth.loggedIn && this.$auth.user?.role?.identifier === 'admin'
      )
    },

    allVariants() {
      if (this.product.selectable_variants?.length) {
        return this.product.selectable_variants
      }
      return this.product.variant ? [this.product.variant] : []
    },

    totalStock() {
      return this.allVariants.reduce(
        (sum, v) => sum + (v.quantity_available || 0),
        0
      )
    },

    totalSales30Days() {
      return Object.values(this.variantsStats).reduce(
        (sum, stat) => sum + (stat.sales_30_days || 0),
        0
      )
    },

    totalSalesAllTime() {
      return Object.values(this.variantsStats).reduce(
        (sum, stat) => sum + (stat.total_sales || 0),
        0
      )
    },

    urlToAdminPage() {
      return `${this.$config.adminUrl}/produits/${this.product.id}?variant=${this.product.variant?.id}`
    },
  },

  watch: {
    'product.id': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.variantsStats = {}
          this.fetchAdminStats()
        }
      },
    },
    isAdmin: {
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(this.variantsStats).length === 0) {
          this.fetchAdminStats()
        }
      },
    },
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded && Object.keys(this.variantsStats).length === 0) {
        this.fetchAdminStats()
      }
    },

    async fetchAdminStats() {
      if (!this.isAdmin || !this.product?.id) return

      this.loading = true
      try {
        const response = await this.$productService.getAdminStats(
          this.product.id
        )
        this.variantsStats = response.data?.variants_stats || {}
      } catch (error) {
        console.error('Failed to fetch admin stats:', error)
      } finally {
        this.loading = false
      }
    },

    getVariantStats(variantId) {
      return this.variantsStats[variantId] || {}
    },

    formatLastSale(dateStr) {
      if (!dateStr) return '-'
      return this.$options.filters.dateAgo(dateStr)
    },

    getStockClass(stock) {
      if (stock <= 0) return 'tw-text-red-500 tw-font-bold'
      if (stock < 5) return 'tw-text-orange-400'
      if (stock < 20) return 'tw-text-yellow-400'
      return 'tw-text-green-400'
    },
  },
}
